import { useMutation, useQueryClient } from '@tanstack/react-query'
import { authApi } from '../api/auth.api'
import { LoginCredentials, LoginResponse } from '../types'
import { STORAGE_KEYS } from '@/shared/constants'

/**
 * Hook for user login
 */
export function useLogin() {
  const queryClient = useQueryClient()

  return useMutation<LoginResponse, Error, LoginCredentials>({
    mutationFn: authApi.login,
    onSuccess: async (data, variables) => {
      const accessToken = data.data.tokens.access_token
      const refreshToken = (data.data.tokens as any).refresh_token
      const expiresIn = data.data.tokens.expires_in
      const refreshExpiresIn = data.data.tokens.refresh_expires_in

      localStorage.setItem(STORAGE_KEYS.AUTH_TOKEN, accessToken)
      localStorage.setItem(STORAGE_KEYS.AUTH_TOKEN_EXPIRES_AT, String(Date.now() + expiresIn * 1000))

      if (refreshToken) {
        localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, refreshToken)
      }

      if (refreshExpiresIn) {
        localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN_EXPIRES_AT, String(Date.now() + refreshExpiresIn * 1000))
      }

      localStorage.setItem(STORAGE_KEYS.LOGIN_CREDENTIALS, JSON.stringify(variables))

      const user = data.data.user
      if (user?.id) {
        localStorage.setItem(STORAGE_KEYS.USER, JSON.stringify(user))

        try {
          await queryClient.prefetchQuery({
            queryKey: ['rbac', 'module-config', user.id],
            queryFn: () => authApi.getUserModuleConfig(user.id),
          })
        } catch (e) {
          console.error('Prefetch module config failed:', e)
        }
      }
    },
    onError: (error) => {
      console.error('Login failed:', error)
    },
  })
}

